// components/ConversionScript.tsx
'use client';

import Script from 'next/script';

export default function ConversionScript() {
  return (
    <Script id="gtag-conversion" strategy="afterInteractive">
      {`
        function gtag_report_conversion(url) {
          var callback = function () {
            if (typeof(url) != 'undefined') {
              window.location = url;
            }
          };
          gtag('event', 'conversion', {
              'send_to': 'AW-10850056457/g__zCKnBwsYaEIny2rUo',
              'event_callback': callback
          });
          return false;
        }
      `}
    </Script>
  );
}